<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
@if (dataSource?.hasHtml$ | async) {
  <div [innerHTML]="dataSource?.reportHtml"></div>
} @else {
  <div class="detail-table-container">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="label">
        <th mat-header-cell *matCellDef="let row">{{ row.label }}</th>
      </ng-container>
      <ng-container matColumnDef="value">
        <td mat-cell *matCellDef="let row">
          <dash-gis-base-field [fieldDefinition]="row.field" [rowData]="row"
          [tableEditActive]="false"></dash-gis-base-field>
        </td>
      </ng-container>
      <tr mat-row *matRowDef="let rowData; columns: columnsToDisplay"></tr>
    </table>
  </div>
}


<div #attributions></div>
